"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: function (_a) {
            var fullWidth = _a.fullWidth, fillContainer = _a.fillContainer;
            return fullWidth ? (fillContainer ? '100%' : '100vw') : 'auto';
        },
        height: function (_a) {
            var fullHeight = _a.fullHeight, fillContainer = _a.fillContainer;
            return fullHeight ? (fillContainer ? '100%' : '100vh') : 'auto';
        },
    },
});
exports.default = react_1.forwardRef(function PagePreloader(_a, ref) {
    var _b = _a.fullHeight, fullHeight = _b === void 0 ? true : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, _d = _a.fillContainer, fillContainer = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? 64 : _e, circularProgressProps = __rest(_a, ["fullHeight", "fullWidth", "fillContainer", "size"]);
    var classes = useStyles({ fullWidth: fullWidth, fullHeight: fullHeight, fillContainer: fillContainer });
    return (jsx_runtime_1.jsx("div", __assign({ className: classes.wrapper, ref: ref }, { children: jsx_runtime_1.jsx(CircularProgress_1.default, __assign({}, circularProgressProps, { size: size }), void 0) }), void 0));
});
//# sourceMappingURL=PagePreloader.js.map